import React from 'react';
import { branch, renderComponent, compose, withHandlers } from 'recompose';
import { CartWrapper, CartItemWrapper } from './style';
import CartFooter from './cartFooter';
import CartSummary from './cartSummary';
import CartHeader from './cartHeader';
import CartItem from './cartItem';
import EmptyData from '../../images/emptyData';
import { ActionButton } from '../buttons';
import { CartLoading } from '../loading';

const Cart = ({
  onCartClose,
  itemsCount,
  items,
  onDeleteCartItem,
  ...rest
}) => {
  const cartItems = items.map(item => {
    const { articleID } = item;
    return (
      <CartItem
        key={articleID}
        onDeleteCartItem={() => onDeleteCartItem({ articleID })}
        {...item}
      />
    );
  });

  return (
    <CartWrapper>
      <CartHeader onCartClose={onCartClose} itemsCount={itemsCount} />
      {itemsCount > 0 ? (
        <React.Fragment>
          <CartItemWrapper>{cartItems}</CartItemWrapper>
          <CartSummary {...rest} />
          <CartFooter onCartClose={onCartClose} />
        </React.Fragment>
      ) : (
        <div
          css={`
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            padding: 0 16px;
          `}
        >
          <EmptyData width={200} height={300} />
          <ActionButton onClick={onCartClose}>Weiter einkaufen</ActionButton>
        </div>
      )}
    </CartWrapper>
  );
};

const spinnerWhileLoading = isLoading =>
  branch(isLoading, renderComponent(() => <CartLoading />));

const enhance = compose(
  spinnerWhileLoading(props => props.cartStatus === 'fetching' || !props.id),
  withHandlers(initialProps => {
    const { id } = initialProps;
    return {
      onDeleteCartItem: props => ({ articleID }) => {
        return props.onDeleteCartItem({ id, articleID });
      },
    };
  })
);

export default enhance(Cart);



// WEBPACK FOOTER //
// ./src/components/cart/index.js